import Logo from '@/commons/logo';
import { useAuthContext } from '@/hooks/useAuthContext';
import useOffSetTop from '@/hooks/useOffSetTop';
import RouterLink from '@/routes/router-link';
import { bgBlur } from '@/utils';
import { Box, Typography } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Toolbar from '@mui/material/Toolbar';
import { useTheme } from '@mui/material/styles';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';
import { HEADER } from '../config-layout';
import HeaderShadow from './header-shadow';




export default function HeaderSimple() {
  const theme = useTheme();
  const { logout, user } = useAuthContext();
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar();

  const handleLogout = async () => {
    try {
      logout();
      navigate('/auth/login', { replace: true });
      // handleClosePopover();
    } catch (error) {
      console.error(error);
      enqueueSnackbar('Unable to logout!', { variant: 'error' });
    }
  };

  const phone = 573014843110;
  const offsetTop = useOffSetTop(HEADER.H_DESKTOP);

  return (
    <AppBar
      sx={{
        ...bgBlur({
          color: theme.palette.background.default,
        }),
      }}
    >
      <Toolbar
        sx={{
          justifyContent: 'space-between',
          height: {
            xs: HEADER.H_MOBILE,
            md: HEADER.H_DESKTOP,
          },
          transition: theme.transitions.create(['height'], {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.shorter,
          }),
          ...(offsetTop && {
            ...bgBlur({
              color: theme.palette.background.default,
            }),
            height: {
              md: HEADER.H_DESKTOP_OFFSET,
            },
          }),
        }}
      >
        <Logo />

        <Stack direction="row" alignItems="center" spacing={4}>
          <Link
            href={`https://api.whatsapp.com/send?phone=${phone}&text=Necesito%20soporte%2C%20porfavor`}
            component={RouterLink}
            color="primary"
            sx={{ typography: 'subtitle2' }}
          >
            Need help?
          </Link>

          <Box onClick={handleLogout} sx ={{cursor : 'pointer'}}>
            <Link color="primary" fontWeight='bold'>Cerrar Sesión</Link>
          </Box>
        </Stack>
      </Toolbar>

      {offsetTop && <HeaderShadow />}
    </AppBar>
  );
}
